import React, { useCallback, useState } from "react";

import SyncIcon from "@mui/icons-material/Sync";
import { Button, Stack, Typography } from "@mui/material";
import { useDealParamsHooks } from "hooks";
import { useDealActions, useDealFormAiDataSelect } from "store";
import { IAiFile } from "store/types";

interface IProps {
  setFilesPickerModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AiFilesList: React.FC<IProps> = ({ setFilesPickerModalOpen }) => {
  const formAiData = useDealFormAiDataSelect();
  const [seeAll, setSeeAll] = useState<boolean>(false);
  const { aiAnswerFormAction, getFoldersAction, getDealFormAndStoreAction } = useDealActions();
  const { dealId, formId } = useDealParamsHooks();

  const regenerateAnswers = useCallback(async () => {
    if (!formAiData.ai_files?.length) return;
    await aiAnswerFormAction({ dealId, formId, file_ids: formAiData.ai_files.map((file: IAiFile) => file.id) });
    await getFoldersAction({ dealId });
    await getDealFormAndStoreAction({ dealId, formId, disableLoading: true });
  }, [formAiData, dealId]);

  return (
    Boolean(formAiData.ai_files?.length) && (
      <Stack sx={{ backgroundColor: "#F6F8FC", padding: "20px" }} gap="10px">
        {formAiData.ai_files?.length ? (
          <>
            <Typography sx={{ fontSize: "15px", fontWeight: "500", color: "#071F35" }}>Ask AI</Typography>

            <Typography sx={{ fontSize: "12px", fontWeight: "400", color: "#071F35" }}>
              {formAiData.ai_files?.length} files selected:
            </Typography>

            <Stack sx={{ maxHeight: seeAll ? "100%" : "70px", overflow: "hidden" }}>
              {formAiData.ai_files?.map((file: IAiFile) => (
                <Typography sx={{ fontSize: "12px", fontWeight: "400", color: "#496682" }} key={file.id}>
                  {file.name}
                </Typography>
              ))}
            </Stack>
            {!seeAll && formAiData.ai_files.length > 4 && (
              <Typography
                onClick={() => setSeeAll((prev) => !prev)}
                sx={{ fontSize: "12px", fontWeight: "400", color: "#26A6AE", cursor: "pointer" }}
              >
                See all
              </Typography>
            )}
          </>
        ) : null}
        <Stack direction="row" gap="10px">
          <Button
            disabled={formAiData.ai_status === "in-progress"}
            size="sm"
            variant="outlined"
            sx={{ minWidth: "60px !important", maxWidth: "60px !important", background: "#fff", whiteSpace: "nowrap" }}
            onClick={() => setFilesPickerModalOpen(true)}
          >
            Edit files
          </Button>
          <Button
            disabled={!formAiData.ai_files?.length || formAiData.ai_status === "in-progress"}
            size="sm"
            variant="contained"
            sx={{
              minWidth: "155px !important",
              maxWidth: "155px !important",
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              whiteSpace: "nowrap"
            }}
            onClick={regenerateAnswers}
          >
            <SyncIcon sx={{ color: "#fff", width: "16px" }} />
            Regenerate all answers
          </Button>
        </Stack>
      </Stack>
    )
  );
};
